import {connect} from 'react-redux';
import {get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import {
  deleteReminder,
  saveCheckInReminder,
  updateCheckInReminder,
} from '/redux/action/candidate.action';
import {credentialsEmail} from '/redux/selector/auth.selector';
import {
  candidateNameById,
  hasReminderDetails,
  reminderDetailsById,
} from '/redux/selector/candidate.selector';
import {
  highestAchievedRankDescriptionById,
  paidAsRankDescLastMonth,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {allReportData} from '/redux/selector/report.selector';
import {fromProps, withProps} from '/util/selector.util';

import ReminderForm from './ReminderForm';

const withCandidateId = withProps({
  candidateId: fromProps(get('candidateId')),
});

export default connect(
  createStructuredSelector({
    allReportData: allReportData,
    coachEmail: credentialsEmail,
    reminderDetails: reminderDetailsById,
    candidateName: withCandidateId(candidateNameById),
    hasReminderDetails,
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    highest_achieved_rank: withProps({coachId: userId})(
      highestAchievedRankDescriptionById,
    ),
  }),
  dispatch => ({
    saveCheckInReminder: ({reminderData, candidateId, reportData}: any) =>
      dispatch(
        // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
        saveCheckInReminder({
          reminderData,
          candidateId,
          allReportData: reportData,
        }),
      ),
    updateCheckInReminder: ({reminderData, candidateId, reportData}: any) =>
      dispatch<any>(
        updateCheckInReminder({
          reminderData,
          candidateId,
          allReportData: reportData,
        }),
      ),
    deleteReminder: ({candidateId}: any) =>
      dispatch<any>(deleteReminder({candidateId})),
  }),
  (stateProps, dispatchProps, ownProps) => {
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      saveCheckInReminder: ({reminderData, candidateId}: any) => {
        const {allReportData} = stateProps;

        return dispatchProps.saveCheckInReminder({
          reminderData,
          candidateId,
          reportData: allReportData,
        });
      },
      updateCheckInReminder: ({reminderData, candidateId}: any) => {
        const {allReportData} = stateProps;
        return dispatchProps.updateCheckInReminder({
          reminderData,
          candidateId,
          reportData: allReportData,
        });
      },
      deleteReminder: async (candidateId: any) => {
        return dispatchProps.deleteReminder({candidateId});
      },
    };
  },
)(ReminderForm);
